// Shared Work Orders constants + display helpers.
// Status/priority values match the D1 CHECK constraints in
// api/migrations/0001_initial_schema.sql.

export const WO_STATUSES = ["open", "in_progress", "on_hold", "completed", "cancelled"] as const;
export const WO_PRIORITIES = ["low", "normal", "high", "urgent"] as const;
export const WO_CATEGORIES = [
  "maintenance",
  "cleaning",
  "plumbing",
  "electrical",
  "hvac",
  "appliance",
  "safety",
  "other",
] as const;

const STATUS_LABELS: Record<string, string> = {
  open: "Open",
  in_progress: "In progress",
  on_hold: "On hold",
  completed: "Completed",
  cancelled: "Cancelled",
};

const PRIORITY_LABELS: Record<string, string> = {
  low: "Low",
  normal: "Normal",
  high: "High",
  urgent: "Urgent",
};

export function woStatusLabel(s: string): string {
  return STATUS_LABELS[s] ?? s;
}

export function woPriorityLabel(p: string): string {
  return PRIORITY_LABELS[p] ?? p;
}

export function woCategoryLabel(c: string): string {
  if (!c) return "";
  if (c === "hvac") return "HVAC";
  return c.charAt(0).toUpperCase() + c.slice(1);
}

export function formatWoId(id: number): string {
  return "WO-" + String(id).padStart(3, "0");
}

// "2026-05-21" -> "May 21, 2026"; null -> "—".
export function formatDate(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

// True when a non-terminal work order is past its due date.
export function isOverdue(status: string, dueDate: string | null): boolean {
  if (!dueDate || status === "completed" || status === "cancelled") return false;
  const today = new Date().toISOString().slice(0, 10);
  return dueDate < today;
}
